import { FilterTypes } from '../../../../shared/filters/enums/filter-types.enum';
import { SingleFilterOption } from '../../../../shared/filters/enums/single-filter-option.enum';
import { FilterParams } from '../../../../shared/filters/model/filter-params.class';
import { ActiveLocationsFilterRequestParams } from './active-locations-filter-request-params.contract';

export class ActiveLocationsFilterParams extends FilterParams {
  constructor() {
    super();
  }

  getFilterParams(): ActiveLocationsFilterRequestParams {
    return {
      types: this.getFilterTypeParams(FilterTypes.TYPE),
      categories: this.getFilterTypeParams(FilterTypes.CATEGORY),
      costCenters: this.getFilterTypeParams(FilterTypes.COST_CENTER),
      organisations: this.getFilterTypeParams(FilterTypes.ORGANISATION),
      labels: this.getFilterTypeParams(FilterTypes.LABEL),
      matchAllLabels: !this.getFilterTypeParams(FilterTypes.MATCH_ALL_LABELS).includes(SingleFilterOption.ALL_LABELS),
    };
  }
  clone(): ActiveLocationsFilterParams {
    return this.cloneTo(new ActiveLocationsFilterParams());
  }
}
